module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_c('a', {
    attrs: {
      "id": "also"
    }
  }), _vm._v("Also by Dawn Lanuza")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Last Time I’ll Write About You")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Boyfriend Backtrack")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("What About Today")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Hometown Hazard")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Break-Up Anniversary")])])]), _vm._v(" "), _c('div', {
    staticClass: "pb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame c t3",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "poem ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "ded"
    }
  }), _vm._v("To Phoebe,"), _c('br'), _vm._v("May flowers always"), _c('br'), _vm._v("bloom on your day.")])]), _vm._v(" "), _c('div', {
    staticClass: "pb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/blank.gif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "poem-title2 t3"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v("how it starts")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/How_It_Bends.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("how to love in the dark")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("No one knows how to love me when I’m sad")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("and I can’t blame them for that")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I don’t even know how to love me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("when the voices come at night")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I hate and hate and hate")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("even when I fight.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("No one knows how to love me when I’m mad")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("and I can’t blame them for that")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I don’t even know how to stop me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("when my voice gets loud")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I hate and hate and hate")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("even when I muffle the sound.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("No one knows how to love me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("the way I am learning now")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("it takes time and patience,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("tears and self-doubt")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I hope and hope and hope")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("someone will come around.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("What a whiny,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("self-absorbed girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("She thinks the worst of herself")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("when no one even cared")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to say a thing or two at all.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("all this wanting")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I know about wanting.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I wanted a lot of things.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("As a child, I wanted to have")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("a life-sized baby doll")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("feed it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("bathe it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("comb its hair")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I saw it on TV, and I ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("wanted it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("wanted it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("wanted it.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("As a teenager, I wanted to meet ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("this rock band")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("watch backstage")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("go on tour")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("fall in love with the man")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I heard their song on the radio and I")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("wanted it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("wanted it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("wanted it.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("Right now, I wanted to be")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("with you")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("catch shows on Friday nights")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("play football")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("shop for records")]), _vm._v(" "), _c('p', {
    staticClass: "poem ParaOverride-3"
  }, [_vm._v("drive around at midnight")]), _vm._v(" "), _c('p', {
    staticClass: "poem ParaOverride-3"
  }, [_vm._v("watch those shows on your couch")]), _vm._v(" "), _c('p', {
    staticClass: "poem ParaOverride-3"
  }, [_vm._v("ruffle your hair")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("touch your face")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("kiss you good night and I")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("want it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("want it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I want you so bad.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("I know I said I know all about wanting")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("but I don’t know a thing about having. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("I haven’t met you")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("but I already felt like")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I was losing you")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("sad girl")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The first boy she ever loved")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("told her she had sad eyes")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("but changed his mind quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Instead, he called her eyes pretty.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("She didn’t know how to disagree:")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("take it back, ’cause see— ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("she was sad, she needed someone ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("to not call her reasons petty.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("She didn’t need the praise")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("he thought she required.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("She needed company")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("as she learned to speak her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("Her sad eyes learned first")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("to say what she couldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Isn’t it sad that he couldn’t stay")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("long enough to hear it?")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("the mechanic")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You tinkered with this heart")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("made sure it worked fine")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("screwed back the falling pieces")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("before leaving it behind.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("canceled plans")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Didn’t we talk about this?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We said we’d take on projects,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("learn musical instruments,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("take culinary classes, ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("write a goddamned book.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Well, I did the last bit.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The last I heard from you, ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("you started running in marathons,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("the last thing I would’ve put on our “to-do list”")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("but hey,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("we’re no longer present in the future ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("we once imagined in the past.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("the perfect plate")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("When I think of you")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I recall silly things.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Glazed doughnuts,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("chocolate chip frappé,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("linguini carbonara.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Did I ever tell you that I hate carbonara?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("But I eat it anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I keep thinking, ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("It’ll get better")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("just like you and me.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And maybe once I find that perfect plate")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("you and I will have the same fate.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We’ll have better timing;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("we’ll finally be on the same page.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("pass the message")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And all I wanted was someone to tap")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("like in one of those games I played as a child")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I didn’t even need a grand gesture")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I just wanted to")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("Feel a pulse to dance along to,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("some skin to touch,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("a warmth to embody")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("before I lift my hand")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("See the pressure roll off")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("watch it travel to abled arms ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("feel it say,"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("Don’t worry, I’ve got your back.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("bad kisser")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I regretted kissing you;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("it was just so bad.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I wish I could kiss you more and more")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("to rid us of the last one we had.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("araneta")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("And isn’t it funny how I used to kiss you on your lips?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Now I have to settle for your cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("Isn’t it funny how you used to ask me, “Stay, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("now I have to get in this cab and watch you leave.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("And the boy who wanted her to stay")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("was one of the first ones who went away ")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("imaginary futures")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You’ve painted a nice future for me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("one where I’m right by the sea")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("surrounded by books, drinking my tea.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("I envisioned this future you imagined for me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("one where I’m looking out the balcony.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("The sky is blue, the horizon is endless.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("I’m sorry, but how come you’re not in this?")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("the breakup")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("Are we breaking up?")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I haven’t answered the question ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("but I could already see the strings snap,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("watch the pieces of the puzzle fall out.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("It was like standing in the middle of a museum")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("looking at the things we built in frames.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Nothing seemed wrong from afar")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("but we knew that the paint was chipping away.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("Are we breaking up?")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("As if it were my decision.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You already did everything to make me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("say yes to the question.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("the museum of unfinished things")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("We painted these walls")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("with our stories")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I’m watching the chips fall")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("crying")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("Weren’t we building a masterpiece?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("How come we’re leaving it unfinished?")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("passing through")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Missing you is a tidal wave,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("it swallows me whole.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("It reminds me of something bigger")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("than what I’ve settled for.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("Your love is a vast ocean")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("with depths of still unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I was accustomed to silent rivers,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("lovers who simply tread along.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("My heart had cracks,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("it couldn’t contain it all.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Your love went past me")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("and found a better home.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("the new normal")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Nothing’s changed.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You still watch the same shows")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("listen to the same songs")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("wear the same clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You just lost me, that’s all.")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("you were my first draft")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("You accused me of holding back")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("even when")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("you had")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("all of my")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("unedited ")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("parts")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("that is so last season")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I wish you witnessed")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("the stars in my eyes")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("the rhyme in my voice")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("my heart on my sleeve")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I rarely wore it")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("but with you, I did.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("Shame you never saw it;")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("shame you never will again.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "PT---left"
  }, [_vm._v("travelers"), _c('span', {
    staticClass: "CharOverride-2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "prose"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I was a substitute: someone you talked to while you got over someone you met before we did. I was the transition, how to pass time as you moved from point A to point B. ")])]), _vm._v(" "), _c('p', {
    staticClass: "prose"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And I never knew how to keep people. I could never just hold on. Part of me always wants to go, to wander, to roam. But then—you were slipping away first.")])]), _vm._v(" "), _c('p', {
    staticClass: "prose"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("So I made it into a competition, found you a replacement soon as you started to do the same. He was temporary—as expected—but you found someone more comfortable with the word ")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("permanent. ")])]), _vm._v(" "), _c('p', {
    staticClass: "prose"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("And while I would rather avoid watching you shower her with your affection like you did with me, I couldn’t help but stare. We were in the same town. We run in the same circles. Every day, I felt a twinge turn into a pinch, until it was squeezing, draining, heart-wrenching. ")])]), _vm._v(" "), _c('p', {
    staticClass: "prose"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("I always thought, ")]), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("But that was me, not so long ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "prose"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Despite telling myself that you were never the guy for me. You were a substitute, someone who showed up with bandages when my heart had scratches. You were the boost that I needed, all kind words and good intentions, but always wondering, curious, full of life. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "runover-poems pb",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "poem ParaOverride-2"
  }, [_vm._v("See, I was never that girl for you. ")]), _vm._v(" "), _c('p', {
    staticClass: "poem ParaOverride-2"
  }, [_vm._v("I was just a tourist attraction. ")]), _vm._v(" "), _c('p', {
    staticClass: "poem ParaOverride-2"
  }, [_vm._v("But you were that guy for me.")]), _vm._v(" "), _c('p', {
    staticClass: "poem ParaOverride-4"
  }, [_vm._v("You’ve always been my go-to destination.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1 pb",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_vm._v("There are a thousand ways")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("to say I miss you but")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I could never just")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("let those words")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("roll off of my tongue")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("to get the job done")])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "poem-title"
  }, [_vm._v("I was here")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("I picked that shirt that you were wearing")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("in this photo that you were showing.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Your eyes were blue and smiling,")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("next to this girl that you were dating.")]), _vm._v(" "), _c('p', {
    staticClass: "poem t"
  }, [_vm._v("It made me smile that a part of me was there")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("even when you obviously didn’t care.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("It was my own version of scribbling, "), _c('span', {
    staticClass: "ital CharOverride-4"
  }, [_vm._v("I was here")]), _c('span', {
    staticClass: "ital CharOverride-5"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Even if it was just with who you once were.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c995ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YouAreHere_epub.vue
// module id = 60
// module chunks = 0